import { takeLatest, put, call } from 'redux-saga/effects';
import { actions } from 'ducks/onboarding';
import { findOne } from 'api/helpers/onboarding';
import authenticatorConfSetter from './authenticatorConfSetter';

function* fetchOnboarding({ payload: { data: brand = 'default' } }) {
  try {
    const response = yield call(findOne, brand);
    yield put(actions.success(response));
  } catch (error) {
    yield put(actions.failure(error));
  }
}

export default [
  takeLatest(actions.request, fetchOnboarding),
  takeLatest(actions.success, authenticatorConfSetter),
];
